import { setLocale } from '@/tools/momentUtils';
import i18n from '@/i18n';
import { i18n as svelteI18n } from 'editor-svelte';

export async function reloadLanguage() {
  const language = svelteI18n.getUserLanguageFrom(svelteI18n.LANGUAGES, svelteI18n.DEFAULT_LANGUAGE);

  setLocale(language); // TODO does not change current moment instances!
  i18n.locale = language;
}
